module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyBAMAAADsEZWCAAAABGdBTUEAALGPC/xhBQAAAC1QTFRF2dnZ1NTU0tLS3d3d29vb2NjY39/f0NDQ5eXl1tbW4+Pjzs7O6enpzMzM6+vrG4HEIAAAAPBJREFUOMvd0z0KwjAUB3DPIXgEvYDoqpMX8OMGFVcHnZxdXXRwt13ErR0dtBDQYqUtD8TPUkrOoEYtLz4Dnc2QP+QHyctXhqta5n/lOoJu+5eEeQDYDn+IFlT5wHKphDB+9CsYEjl6IiYFIpopwnaJTGoizh6R3muBcE8EvjKNqGdTV6CuWr1T9emoT5RHvcct7A0qcR2ebcGIFKEz4+sKzL9lCVmRU2jIEued90BpyyS5BJ+lI6slSclPatIdLLFVTuQUMCSXDXqCuRYS20eim0i0PpKbi6RZQ3LYIckZSKINEmBIYsAi/Q/491+fWu4so2bsZwZQZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/avatar-mid-img.png
// module id = VbUe
// module chunks = 27